<template>
	<div class="paid-mobile-wrap">
		<div class="mb-close" @click="closeDetail"></div>
		<div class="mb-title" v-html="versionText.title"></div>
		<div class="content">
			<div class="line">
				<div class="line-left">
					{{ getConstants('USER_ACCOUNT') + getConstants('COLON') }}
				</div>
				<div
					class="line-right line-right-user"
					v-html="userInfo.userName"
				></div>
			</div>
			<div class="line">
				<div class="line-left">
					{{
						getConstants('PRICING_NEW_DETAIL_CURRENT_VERSION') +
							getConstants('COLON')
					}}
				</div>
				<div class="line-right line-version">
					<span class="version">{{ userInfo.version }}</span>
					<i v-if="isPaidUser" :class="isUserExpired ? 'is-user-expired' : ''"
						>({{
							getConstants('PRICING_MOBILE_DETAIL_EXPRIED') +
								' ' +
								userInfo.expireDate
						}})</i
					>
				</div>
			</div>
			<div class="line">
				<div class="line-left">
					{{
						getConstants('PRICING_NEW_DETAIL_TOTAL_STORAGE') +
							getConstants('COLON')
					}}
				</div>
				<div class="line-right">
					{{ userInfo.storage
					}}{{
						PageInfo.storageQuota &&
							` (${getConstants(
								'PRICING_NEW_DETAIL_CURRENT_STORAGE',
							)}${getConstants('COLON')}${PageInfo.storageQuota})`
					}}
				</div>
			</div>
			<div class="line">
				<div class="line-left">
					{{
						getConstants('PRICING_NEW_DETAIL_EXPRIED') + getConstants('COLON')
					}}
				</div>
				<div class="line-right">{{ userInfo.expireDateAfterPay }}</div>
			</div>
			<div class="line">
				<div class="line-left">
					{{
						getConstants('PRICING_NEW_COMMON_EAGLE_PLAN') +
							getConstants('COLON')
					}}
				</div>
				<div class="line-right">{{ versionText.planVersion }}</div>
			</div>
			<div class="line">
				<div class="line-left" style="opacity: 0">
					{{
						getConstants('PRICING_NEW_COMMON_EAGLE_PLAN') +
							getConstants('COLON')
					}}
				</div>
				<div class="line-right">{{ paidModal.content }}</div>
			</div>
		</div>
		<div class="mb-buy">
			<div class="mb-price">¥ {{ price.toFixed(2) }}</div>
			<div class="mb-origin">
				<p class="mb-origin-money">{{ versionText.originPrice }}</p>
				<p class="mb-origin-limit">
					{{ getConstants('PRICING_NEW_EAGLE_SELECT_ORIGIN_SPECIAL') }}
				</p>
			</div>
		</div>
		<div class="mb-paid">
			<e-button v-if="isPaidInvalid" class="not-allowed" type="primary">
				{{ getConstants('PRICING_NEW_DETAIL_NOT_ALLOW') }}
			</e-button>
			<e-button v-else type="primary" @click="pay">
				{{ getConstants('PRICING_MOBILE_PAY') }}
			</e-button>
		</div>
		<div class="mb-tips">{{ paidModal.tip }}</div>
	</div>
</template>
<script>
import { getVersion } from '../../../../utils/accountHelper'
import { formatDate } from '../../../../utils/formate'
import {
	isUserFree,
	isUserExpired,
	getIfPaidInvalid,
} from '../../../../utils/detailHelper'
import { getCouponCode } from '../../../../utils/coupon'
import buyStore from '../../../../utils/buyStore'
import { paidModal } from '../../baseData'

export default {
	props: {
		price: {
			type: Number,
			required: true,
		},
		planData: {
			type: Object,
			required: true,
		},
		version: {
			type: String,
			required: true,
		},
		coupon: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			paidModal,
		}
	},
	computed: {
		userInfo() {
			return {
				userName: unescape(PageInfo.user_name),
				version: this.getConstants(getVersion(PageInfo.accountState)),
				state: PageInfo.accountState,
				expireDate: PageInfo.expireDate
					? formatDate(PageInfo.expireDate, 'yyyy-MM-dd')
					: null,
				storage: this.planData.storage,
				expireDateAfterPay: this.expireDateAfterPay,
			}
		},
		expireDateAfterPay() {
			return formatDate(this.planData.expried)
		},
		isPaidUser() {
			return !isUserFree(PageInfo.accountState)
		},
		// 是否过期
		isUserExpired() {
			return isUserExpired(PageInfo.accountState, PageInfo.expireDate)
		},
		versionText() {
			return paidModal[this.version]
		},
		isPaidInvalid() {
			return getIfPaidInvalid({
				coupon: this.coupon,
				version: this.version,
				timeType: 12,
			})
		},
	},
	methods: {
		closeDetail() {
			buyStore.$emit('closeDetail')
		},
		pay() {
			getCouponCode.then(coupon => {
				if (coupon.isCouponInvalid) {
					location.replace('/s/pricing')
				} else {
					const payLink = `/d/newOrder?month=12&service_plan=${this.planData.plan}&coupon_code=${coupon.coupon_code}`
					location.href = payLink
				}
			})
		},
	},
}
</script>
<style lang="scss" scoped>
.paid-mobile-wrap {
	padding-top: 16px;
	padding-bottom: 20px;
	min-width: 320px;
	position: relative;
	.mb-close {
		position: absolute;
		right: 20px;
		top: 0;
		width: 16px;
		height: 16px;
		background: url('./close.svg') 0 0/16px 16px no-repeat;
	}
	.mb-title {
		line-height: 20px;
		text-align: center;
		font-size: 16px;
		color: #5d5d5d;
	}
	.content {
		padding: 0 18px;
		margin: 15px auto 0;
		max-width: 300px;
	}
	.line {
		display: flex;
		margin-top: 12px;
		font-size: 14px;
		line-height: 20px;
	}
	.line-left {
		min-width: 60px;
		white-space: nowrap;
		margin-right: 10px;
		text-align: right;
	}
	.line-right-user {
		word-break: break-all;
		max-width: 200px;
	}
	.line-version {
		display: flex;
	}
	.is-user-expired {
		color: #ff5252;
	}
	.mb-buy {
		margin-top: 24px;
		padding: 0 20px;
		display: flex;
		background-color: #f5fbff;
		justify-content: space-between;
		.mb-price {
			font-size: 16px;
			text-indent: 26px;
			line-height: 64px;
			color: #303030;
			background: url('./icon_check.svg') left center/18px 18px no-repeat;
		}
		.mb-origin-money {
			font-size: 14px;
			margin-top: 12px;
			color: #b9c8d5;
			text-decoration: line-through;
		}
		.mb-origin-limit {
			margin-top: 4px;
			font-size: 12px;
			color: #4bb490;
		}
	}
	.mb-paid {
		margin-top: 20px;
		text-align: center;
		button {
			width: 280px;
			height: 40px;
			&.not-allowed {
				background: #909090;
				border: none;
			}
		}
	}
	.mb-tips {
		margin-top: 18px;
		padding: 0 12px;
		font-size: 12px;
		line-height: 20px;
		color: #5fb4ff;
	}
}
</style>
